import styled from 'styled-components'
import { readableColor } from 'polished'

import { COLOURS } from 'resources'
import RoundedButton from 'components/RoundedButton'

export const SectionTitle = styled.div`
  margin-bottom: 8px;
  margin-top: 16px;
  font-weight: bold;
  font-size: 24px;
  border-bottom: 1px solid ${COLOURS.darkGrey8};
`

export const SectionSubTitle = styled.div`
  margin-bottom: 6px;
  margin-top: 10px;
  font-weight: bold;
  font-size: 20px;
`

export const TitleExample = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 32px;
`
export const RegularExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-size: 18px;
`
export const ItalicExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-style: italic;
  font-size: 18px;
`
export const BoldExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 700;
  font-size: 18px;
`
export const BoldItalicExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 700;
  font-style: italic;
  font-size: 18px;
`
export const ExtraBoldExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 900;
  font-size: 18px;
`
export const ExtraBoldItalicExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 900;
  font-style: italic;
  font-size: 18px;
`
export const SemiBoldExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 600;
  font-size: 18px;
`
export const SemiBoldItalicExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 600;
  font-style: italic;
  font-size: 18px;
`
export const MediumExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 500;
  font-size: 18px;
`
export const MediumItalicExample = styled.div`
  font-family: 'EBGaramond', serif;
  font-weight: 500;
  font-style: italic;
  font-size: 18px;
`

export const ColorDisplayContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const ColorDisplay = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
  border-radius: 4px;
  margin: 8px;
  background-color: ${(props) => props.color};

  &::after {
    content: '${(props) => props.color}';
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    transform: translateY(-50%);
    color: ${(props) => readableColor(props.color)};
    text-align: center;
  }
`

export const StyledButton = styled(RoundedButton)`
  margin-bottom: 10px;
`
